<ng-container *transloco="let t;">
  <app-detail-view [loading]="loading" [messages]="messages" [close]="false">

    <div title>
      <h1>
        {{ t('my_availabilities.my_availabilities') }}
      </h1>
    </div>

    <div details>
      <app-loader [loading]="loading"></app-loader>

      <ng-container *ngIf="loading !== true">
        <form (submit)="onSubmit()" novalidate>
          <div class="p-text-right p-mb-4">
              <button *ngIf="inEdit !== true" pButton [label]="t('common.labels.edit')" (click)="onEdit()" class="p-button-sm"></button>
              <app-form-buttons *ngIf="inEdit === true" [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
          </div>
          <p *ngIf="introText !== null" [innerHtml]="introText"></p>
          <div class="p-grid p-fluid">
            <div class="p-col-12" [ngClass]="{'p-md-8': isModerator === true}">
              <app-appointment-calendar
                [type]="AppointmentCalendarType.Availabilities"
                [inEdit]="inEdit"
                [days]="days"
                [specialdays]="specialdays"
                [min]="setup?.min"
                [minDate]="setup?.minDate"
                [max]="setup?.max"
                [timing]="setup?.timing"
                [size]="(isModerator === true) ? 2 : 3"
                [maxMonths]="setup?.maxMonths"
                [locations]="locations"
                (onDayChange)="onDayChange($event)"
              ></app-appointment-calendar>
            </div>
            <div class="p-col-12 p-md-4">
              <app-observer-list
                *ngIf="isModerator === true"
                [appointments]="observers"
                [locations]="locations"
              ></app-observer-list>
            </div>
          </div>
          <app-appointment-list
            [type]="AppointmentCalendarType.Availabilities"
            [inEdit]="inEdit"
            [days]="days"
            [locations]="locations"
            (onDayChange)="onDayChange($event)"
          ></app-appointment-list>
        </form>
      </ng-container>
    </div>

  </app-detail-view>
</ng-container>
